import {Component, OnInit} from '@angular/core';
import {FormBuilder, Validators, FormGroup, FormControl} from "@angular/forms";
import {AccountBookingService} from "../../services/account-booking.service";
import {AccountsService} from "../../services/accounts.service";
import {AuthenticationService} from "../../services/authentication.service";
import {AlertService} from "../../services/alert.service";
import {LoaderService} from "../../services/loader.service";
import {Router, ActivatedRoute} from "@angular/router";
import * as $ from 'jquery';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.css']
})
export class DepositComponent implements OnInit {
  private moneyRegex = '^([0-9]+|[0-9]*(\.[0-9])([0-9])?)$';
  accountList = [];
  depositForm;
  selectedAccount:any = [];
  selectedAccountDeposit:any = [];
  loading = false;
  accountBookingList = [];
  leftAmount:number = 0;
  advance = 0;

  constructor(private formBuilder:FormBuilder,
              private accountBookService:AccountBookingService,
              private accountsService:AccountsService,
              private authenticationService:AuthenticationService,
              private alertService:AlertService,
              private loaderService:LoaderService,
              private router:Router,
              private route:ActivatedRoute) {
  }

  ngOnInit() {
    this.loaderService.loading(true);
    this.depositForm = this.formBuilder.group({
      account: ['', Validators.required],
      deposit: ['', [Validators.pattern(this.moneyRegex), Validators.required]]
    });
    this.depositForm.controls['account'].valueChanges.subscribe(value => {
      value ? this.selectedAccount[0] = this.accountList.find(a=> a._id == value) : this.selectedAccount = [];
      this.selectedAccountDeposit = value ? this.accountList.find(a=> a._id == value).deposit : [];
      this.selectedAccountDeposit.length ? this.selectedAccountDeposit.sort(function (a, b) {
        return parseFloat(b.date) - parseFloat(a.date);
      }) : null;
      this.advance = value ? this.selectedAccount[0].advance : 0;

      this.leftAmount = 0;
      value ? this.getAccountSPendingBookingList(value) : (this.accountBookingList = []);
    });
    this.getAccountList();
  }

  getAccountList(callback?) {
    this.accountsService
      .list()
      .subscribe(
        data => {
          this.accountList = data || [];
          this.loaderService.loading(false);
          callback ? callback() : null;
        },
        error => {
          this.alertService.error(error);
          this.loaderService.loading(false);
        });
  }

  getAccountSPendingBookingList(value) {
    this.loaderService.loading(true);
    this.accountBookService.getUnPaidRecord({id: value, paid: false}).subscribe(
      data => {
        this.leftAmount = 0;
        this.accountBookingList = data || [];
        this.accountBookingList.length ? this.accountBookingList = this.accountBookingList.filter(l=>!l.paid) : null;
        this.accountBookingList.length ? this.accountBookingList.sort(function (a, b) {
          return parseFloat(a.booking_date) - parseFloat(b.booking_date);
        }) : null;
        this.accountBookingList.length ? this.accountBookingList.forEach(obj=> {
          !obj.paid ? this.leftAmount += obj.pending_amount : null;
        }) : null;
        // this.selectedAccountDeposit.length ? this.selectedAccountDeposit.forEach(a=> this.leftAmount -= parseFloat(a.amount)) : null;
        this.loaderService.loading(false);
      },
      error => {
        this.alertService.error(error);
        this.loaderService.loading(false);
      });
  }

  validateAllFormFields(formGroup:FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
    $(document).ready(function () {
      $('html, body').animate({
        scrollTop: $('.alert-danger').closest('.form-group').offset().top - 56
      }, 500);
    });
  }

  submitDepositForm() {
    this.depositForm.controls.deposit.value > 0 ? this.depositForm.valid ?
      this.accountsService.paymentById(this.selectedAccount[0]._id, {
        deposit: parseFloat(this.depositForm.controls.deposit.value)
      }).subscribe(
        data => {
          this.getAccountList(()=> {
            this.depositForm.patchValue({account: this.selectedAccount[0]._id, deposit: 0});
          });
          this.accountBookingList = [];
        },
        error => {
          this.alertService.error(error);
          this.loaderService.loading(false);
        }
      ) : this.validateAllFormFields(this.depositForm)
      : this.alertService.error("Please Add Valid Amount...");

  }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/deposit/deposit.component.ts